import { useMemo } from "react";

import { useResubscribeNudgeFooterSetting } from "../settings/useSettingResubscribeNudgeVariant";

import { useIsUnsubscribedToMarketingEmails } from "./retailer/useIsUnsubscribedToMarketingEmails";
import { useNationality } from "./retailer/useNationality";

interface ResubscribeEligibility {
  isEligible: boolean;
  isLoading: boolean;
}

export const useResubscribeEligibility = (): ResubscribeEligibility => {
  const { isAmerican, isCanadian, isEurope, isAustralian, isNewZealand } =
    useNationality();
  const { isUnsubscribedToMarketingEmails } =
    useIsUnsubscribedToMarketingEmails();
  const isResubscribeNudgeFooterCohort = useResubscribeNudgeFooterSetting();

  return useMemo(() => {
    if (!isResubscribeNudgeFooterCohort) {
      return {
        isEligible: false,
        isLoading: false,
      };
    }

    // Only eligible in supported countries: USA, CAN, Europe, AUS, NZL
    const isInSupportedCountry =
      isAmerican || isCanadian || isEurope || isAustralian || isNewZealand;

    if (!isInSupportedCountry) {
      return {
        isEligible: false,
        isLoading: false,
      };
    }

    // Only eligible if currently unsubscribed
    if (!isUnsubscribedToMarketingEmails) {
      return {
        isEligible: false,
        isLoading: false,
      };
    }

    return {
      isEligible: true,
      isLoading: false,
    };
  }, [
    isAmerican,
    isCanadian,
    isEurope,
    isAustralian,
    isNewZealand,
    isUnsubscribedToMarketingEmails,
    isResubscribeNudgeFooterCohort,
  ]);
};
